﻿$.fn.dxCtrlFichier2Popup = function custom_dxCtrlFichier2Popup(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2popup dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Popup(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Popup = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var ctrlFichierLstThumb = null;
    //var ctrlResize = null;
    var popupContentElement = null
    var $DivDetail = null
    function mConstruit() {
        container.empty()
        container.remove()

        var pop = container.appendTo("body").dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                contentElement.css("position", "relative")
                contentElement.css("padding", "5px")
                popupContentElement = contentElement

                dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:2px'/>").appendTo(contentElement).dxCtrlButton({
                    icon: 'fas fa-times',
                    width: HeightButton,
                    height: HeightButton,
                    onClick: function (e) {
                        pop.hide();
                    }
                }).dxCtrlButton("instance");
            },
            onShown: function () {
                if (parametre.isMobile) {
                    mRempliVisu(option.selectedItem)
                } else {
                    //var $Table = $("<table style='width:100%'/>").appendTo(popupContentElement)
                    //var $Tr = $("<tr/>").appendTo($Table)
                    //var $TdLst = $("<td style='width:160px'/>").appendTo($Tr)

                    var $DivLst = $("<div style='position:absolute;top:0;left:0;height:100%;width:200px;border-right:" + theme.border + ";'/>").appendTo(popupContentElement)
                    $DivDetail = $("<div style='position:absolute;top:0;right:0;height:100%;width:calc(100% - 200px);'/>").appendTo(popupContentElement)
                    ctrlFichierLstThumb = $("<div/>").appendTo($DivLst).dxCtrlFichier2LstThumb({
                        bddCtrl: option.bddCtrl,
                        readOnly: option.readOnly,
                        selectedItem: option.selectedItem,
                        dataSource: option.dataSource,
                        onReorder: option.onReorder,
                        onDemandeAddFiles: option.onDemandeAddFiles,
                        onDeleteAllFiles: function () {
                            ctrlFichierLstThumb.mClear()
                            var lstItemDataToDel = []
                            option.dataSource.forEach(function (itemData) { lstItemDataToDel.push(itemData) })
                            option.onDeleteFiles(lstItemDataToDel)
                            ctrlFichierLstThumb.mSelect(null)
                        },
                        onSelectionChanged: function (itemData) {
                            mRempliVisu(itemData)
                        }
                    }).dxCtrlFichier2LstThumb("instance")

                    //$TdDetail = $("<td style='width:100%'/>").appendTo($Tr)


                    //ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(popupContentElement).dxCtrlSplitterResize2({
                    //    bddCtrl: option.bddCtrl,
                    //    context_grid: "splitterfile",
                    //    widthLeftInitial: 160
                    //}).dxCtrlSplitterResize2("instance")

                    //ctrlResize.mConstruitLeft(function (contentElementLeft) {
                    //    ctrlFichierLstThumb = $("<div/>").appendTo(contentElementLeft).dxCtrlFichier2LstThumb({
                    //        bddCtrl: option.bddCtrl,
                    //        readOnly: option.readOnly,
                    //        selectedItem: option.selectedItem,
                    //        dataSource: option.dataSource,
                    //        onReorder: option.onReorder,
                    //        onDemandeAddFiles: option.onDemandeAddFiles,
                    //        onDeleteAllFiles: function () {
                    //            ctrlFichierLstThumb.mClear()
                    //            var lstItemDataToDel = []
                    //            option.dataSource.forEach(function (itemData) { lstItemDataToDel.push(itemData) })
                    //            option.onDeleteFiles(lstItemDataToDel)
                    //            ctrlFichierLstThumb.mSelect(null)
                    //        },
                    //        onSelectionChanged: function (itemData) {
                    //            mRempliVisu(itemData)
                    //        }
                    //    }).dxCtrlFichier2LstThumb("instance")
                    //})

                    if (typeof option.selectedItem != 'undefined' && option.selectedItem != null) {
                        mRempliVisu(option.selectedItem)
                    } else {
                        if (option.dataSource.length > 0) mRempliVisu(option.dataSource[0])
                    }
                }
            },
            onHiding: option.onHiding
        }).dxCtrlPopupBase("instance")
        pop.show()

    }

    var currentDivVisu = null
    function mRempliVisu(itemData) {
        if (parametre.isMobile) {
            mRempli(popupContentElement)
        } else {
            mRempli($DivDetail)
            ////ctrlResize.mConstruitRight(function (contentElementLeft) {
            ////    mRempli(contentElementLeft)
            ////})
        }

        function mRempli(contentElement) {
            //contentElement.css("position", "relative")
            //contentElement.css("padding-left", "5px")
            if (currentDivVisu != null) {
                var divVisuFadeOut = currentDivVisu
                divVisuFadeOut.fadeOut(300, function () { divVisuFadeOut.remove() })
            }
            var newCurrentVisu = $("<div style='position:absolute;width:100%;height:100%;'>").appendTo(contentElement)
            newCurrentVisu.hide()
            var dxCtrlFichierVisu = $("<div style='width:100%;height:100%;'/>").appendTo(newCurrentVisu).dxCtrlFichier2Visu({
                bddCtrl: option.bddCtrl,
                readOnly: option.readOnly,
                itemData: itemData,
                onDeleteFile: function (ItemDataToDel) {
                    //on sélectionne le prochain item selectionné
                    var itemToSelect = null
                    if (option.dataSource.indexOf(ItemDataToDel) == option.dataSource.length - 1) {
                        //c'est le dernier
                        if (option.dataSource.length > 1) itemToSelect = option.dataSource[option.dataSource.length - 2]
                    } else {
                        //c'est pas le dernier (ni le premier)
                        //on sélectionne le suivant
                        itemToSelect = option.dataSource[option.dataSource.indexOf(ItemDataToDel) + 1]
                    }
                    ctrlFichierLstThumb.mRemoveThumbItemData(ItemDataToDel)
                    option.onDeleteFiles([ItemDataToDel])
                    ctrlFichierLstThumb.mSelect(itemToSelect)
                }
            }).dxCtrlFichier2Visu("instance")
            newCurrentVisu.fadeIn(300)
            currentDivVisu = newCurrentVisu
        }
    }

    this.mAddNewItemData = function (lstNewItemData) {
        ctrlFichierLstThumb.mAddNewItemData(lstNewItemData)
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}